import React, { useEffect, useState } from 'react';
import { Card, CardBody, Button } from 'reactstrap';
import { CSVLink } from "react-csv";
import IntlMessages from '../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../components/DatatablePagination';

const NudgesClickStats = ({ labels, data, fromDate, toDate, propertyId }) => {
    const [csvData, setCSVData] = useState([]);
    useEffect(() => {
        var tablePrint = [
            { r1: "Nudges Stats", r2: "" },
            {},
            { r1: "Start Date :" + fromDate, r2: "End Date :" + toDate },
            {},
            { r1: "Title", r2: "Clicks" },
        ];
        if (data && data.length > 0) {
            data.map(elem => {
                tablePrint.push({ r1: elem.title, r2: elem.clicks })
            });
        }
        setCSVData(tablePrint);
    }, [data]);
    if (propertyId !== "-1") {
        return null;
    }
    return (
        < Card >
            <div style={{ padding: '15px' }}>
                <div className="float-left float-none-xs">
                    <div className="d-inline-block">
                        <h5 className="d-inline">Nudges Stats</h5>
                        <span className="text-muted text-small d-block"> Nudges Stats Topic View </span>
                    </div>
                </div>
                <div className='float-right'>
                    <CSVLink data={csvData} headers={[
                        { key: "r1", label: "" },
                        { key: "r2", label: "" }
                    ]} filename="nudges-stats.csv">
                        <Button color="primary" outline size="xs">
                            <IntlMessages id='dashboards.download' />
                        </Button>
                    </CSVLink>
                </div>
            </div>
            <CardBody>
                <ReactTable
                    data={data}
                    columns={labels}
                    defaultPageSize={5}
                    showPageSizeOptions={true}
                    PaginationComponent={DataTablePagination}
                />
            </CardBody>
        </Card >
    )
}

export default NudgesClickStats
